import { browserHistory } from "react-router";
import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import { routerMiddleware } from "react-router-redux";
import { createTracker } from "redux-segment";
import { queryMiddleware } from "redux-query";
import { createEpicMiddleware } from "redux-observable";
import reducers from "./reducers";
import api from "middleware/api";
import { customMapper } from "middleware/tracker";
import crossFrame from "middleware/cross-frame";
import { rootEpic } from "./epics";

const getQueries = (state) => state.queries;
const getEntities = (state) => state.entities;

export const createAndConfigureStore = () => {
    const tracker = createTracker(customMapper);
    const epicMiddleware = createEpicMiddleware(rootEpic);
    const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
    // Added trace and sanitizer to add more debug functionality and stop redux devtools from crashing
    // @see https://github.com/zalmoxisus/redux-devtools-extension/blob/master/docs/API/Arguments.md
    // @see https://github.com/zalmoxisus/redux-devtools-extension#13-use-redux-devtools-extension-package-from-npm
    // @see https://github.com/zalmoxisus/redux-devtools-extension/blob/master/docs/Troubleshooting.md#excessive-use-of-memory-and-cpu
    // @see https://medium.com/@zalmoxis/improve-your-development-workflow-with-redux-devtools-extension-f0379227ff83
    // TODO: toggle set of state from query parameter
    // (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    //     ? (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
    //           trace: true, // used for Redux DevTools code tracing
    //           traceLimit: 10, // used for Redux DevTools code tracing
    //           stateSanitizer: (state) => state.mutate, // select slice of state object to speed up debug
    //       })
    //     : compose;

    const router = routerMiddleware(browserHistory);

    const middlewares = [
        thunk,
        api,
        queryMiddleware(getQueries, getEntities),
        tracker,
        epicMiddleware,
        router,
        crossFrame,
    ];

    if (process.env.NODE_ENV === "development") {
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        const createLogger = require("redux-logger");
        const logger = createLogger({
            collapsed: true,
            // Added diff and state transform to add more debug functionality and stop redux-logger from hanging
            // diff: true, // show diff in console
            // stateTransformer: (state) => state.mutate, // select slice of state object to speed up debug
        });
        middlewares.push(logger);
    }

    return createStore(reducers, composeEnhancers(applyMiddleware(...middlewares)));
};

let _store;
export const getStore = () => {
    if (!_store) {
        _store = createAndConfigureStore();
    }

    return _store;
};
